import API from "./API";

// TODO delete this one
export default class EventRegistry extends API {
  constructor(parameters = {}) {
    super("/EventRegistry", parameters);
  }


  getPreviousDirectoryEventIfExist(currentEventId) {
    return this.submit("get", `${this.endpoint}/GetPreviousDirectoryEventIfExist/${currentEventId}`)
  }

  updateNumberAndComments(data) {
    return this.submit("post", `${this.endpoint}/UpdateNumberAndComments`, data);
  }
  deleteIntegration(eventId) {
    return this.submit("delete", `${this.endpoint}/DeleteIntegration/?eventId=${eventId}`);
  }

  getContractAssetComponentData(contractId) {
    return this.submit("get", `${this.endpoint}/GetContractAssetComponentData/${contractId}`);
  }
}
